// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N0 } from '@atlaskit/theme/colors';
import { layers } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	position: 'fixed',
	display: 'flex',
	zIndex: layers.modal(),
	top: '0px',
	left: '0px',
	width: '100vw',
	height: '100vh',
	background: token('elevation.surface', N0),
	pointerEvents: 'initial',
});
